import type { AuthRepository, SnsLinkCommand } from '../repository/AuthRepository';
import type { AuthSession } from '../entity/AuthTypes';

export class SnsLinkUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async execute(command: SnsLinkCommand): Promise<AuthSession> {
    if (!command.ticket) throw new Error('ticket is required');
    if (!command.user_email?.trim()) throw new Error('user_email is required');
    if (!command.password) throw new Error('password is required');
    return this.repository.snsLink(command);
  }
}
